import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { getExtendedBusinessEntityQueryOptions } from "~/modules/business-entities/business-entities.queries"
import { PendingInvitations } from "~/modules/invitations/components/pending-invitations"
import {
  BUSINESS_ENTITY_RESOURCE_ROLE_ID,
  BUSINESS_ENTITY_SYSTEM_ROLE_ID,
} from "~/modules/roles-and-permissions/constants"
import type { Role } from "~/modules/roles-and-permissions/roles-and-permissions.service"
import { UnitMembers } from "~/modules/units/components/unit-members"
import type { UnitMember } from "~/modules/units/units.service"

export const Route = createFileRoute(
  "/_protected-layout/_os-layout/business-entities/$businessEntitySlug/members",
)({
  component: BusinessEntityMembers,
})

function BusinessEntityMembers() {
  const { businessEntitySlug } = Route.useParams()

  const { data: businessEntity } = useSuspenseQuery(
    getExtendedBusinessEntityQueryOptions({
      businessEntitySlug,
    }),
  )

  const rolePredicate = (role: Role) => {
    return role.id !== BUSINESS_ENTITY_RESOURCE_ROLE_ID
  }

  const usersPredicate = (member: UnitMember) => {
    return member.role_id !== BUSINESS_ENTITY_RESOURCE_ROLE_ID
  }

  return (
    <div className="space-y-6">
      <PendingInvitations
        unitId={businessEntity.unit_id}
        systemRoleId={BUSINESS_ENTITY_SYSTEM_ROLE_ID}
        rolePredicate={rolePredicate}
      />

      <UnitMembers unitId={businessEntity.unit_id} predicate={usersPredicate} />
    </div>
  )
}
